// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_model from "./web_model.js";
import * as Mapre_web__Web_personal_tokens_model from "./web_personal_tokens_model.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function busy(p) {
  if (p.loading) {
    return true;
  } else {
    return p.pending;
  }
}

function scope_allowed(model, param) {
  switch (param) {
    case /* Read */ 0 :
      return true;
    case /* Execute */ 1 :
    case /* Publish */ 2 :
      return Mapre_web__Web_model.can_create(model);
    case /* Edit_environment */ 3 :
      return Mapre_web__Web_model.can_edit_environment(model);
    case /* Admin */ 4 :
      return Mapre_web__Web_model.can_manage_project(model);
  }
}

function inputs(model, source, send) {
  const partial_arg = "Token name";
  const partial_arg$1 = "Expires in days";
  const partial_arg$2 = "Choose 1 to 365 days. New tokens default to Read for 30 days.";
  const partial_arg$3 = "muted";
  const partial_arg$4 = Stdlib__List.map((function (param) {
    const label = param[1];
    const scope = param[0];
    return function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___001_) {
        const partial_arg = {
          TAG: /* Personal_tokens */ 40,
          _0: {
            TAG: /* Toggle_scope */ 3,
            _0: scope
          }
        };
        const partial_arg$1 = (function (param) {
          return Lui_elements.press(send, partial_arg, param);
        });
        const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (m) {
          if (scope_allowed(m, scope)) {
            return Stdlib__Option.fold(true, (function (p) {
              return !Mapre_web__Web_personal_tokens_model.editable(p);
            }), m.personal_tokens);
          } else {
            return true;
          }
        }), model)));
        const partial_arg$3 = label;
        const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (p) {
          return Stdlib__List.mem(scope, p.scopes);
        }), source)));
        const partial_arg$5 = label;
        return function (param, param$1) {
          return Lui_elements.checkbox(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, partial_arg$4, partial_arg$3, undefined, partial_arg$2, partial_arg$1, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    };
  }), {
    hd: [
      /* Read */ 0,
      "Read"
    ],
    tl: {
      hd: [
        /* Execute */ 1,
        "Execute"
      ],
      tl: {
        hd: [
          /* Publish */ 2,
          "Publish"
        ],
        tl: {
          hd: [
            /* Edit_environment */ 3,
            "Edit environment"
          ],
          tl: {
            hd: [
              /* Admin */ 4,
              "Admin"
            ],
            tl: /* [] */ 0
          }
        }
      }
    }
  });
  const partial_arg$5 = "wrap";
  const partial_arg$6 = 12;
  const partial_arg$7 = Signal.map((function (m) {
    return Mapre_web__Web_types.project(m.route) !== undefined;
  }), model);
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___002_) {
        const partial_arg = (function (param) {
          return Lui_elements.on_input(send, (function (text) {
            return {
              TAG: /* Personal_tokens */ 40,
              _0: {
                TAG: /* Edit */ 2,
                _0: /* Name */ 0,
                _1: text
              }
            };
          }), param);
        });
        const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (p) {
          return !Mapre_web__Web_personal_tokens_model.editable(p);
        }), source)));
        const partial_arg$2 = "Token name";
        const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (p) {
          return p.name;
        }), source)));
        return function (param, param$1) {
          return Lui_elements.text_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___003_) {
            const partial_arg = (function (param) {
              return Lui_elements.on_input(send, (function (text) {
                return {
                  TAG: /* Personal_tokens */ 40,
                  _0: {
                    TAG: /* Edit */ 2,
                    _0: /* Days */ 1,
                    _1: text
                  }
                };
              }), param);
            });
            const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (p) {
              return !Mapre_web__Web_personal_tokens_model.editable(p);
            }), source)));
            const partial_arg$2 = "Expires in days";
            const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map((function (p) {
              return p.days;
            }), source)));
            return function (param, param$1) {
              return Lui_elements.text_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.row(undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, partial_arg$4, param, param$1);
            }),
            tl: {
              hd: (function (param, param$1) {
                return Lui_elements.if_(partial_arg$7, (function (param, param$1) {
                  return Lui_elements.scoped((function (__lui_context___004_) {
                    const partial_arg = {
                      TAG: /* Personal_tokens */ 40,
                      _0: /* Toggle_project */ 4
                    };
                    const partial_arg$1 = (function (param) {
                      return Lui_elements.press(send, partial_arg, param);
                    });
                    const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (p) {
                      return !Mapre_web__Web_personal_tokens_model.editable(p);
                    }), source)));
                    const partial_arg$3 = "Restrict to this project";
                    const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (p) {
                      return p.project_only;
                    }), source)));
                    const partial_arg$5 = "Restrict to this project";
                    return function (param, param$1) {
                      return Lui_elements.checkbox(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, partial_arg$4, partial_arg$3, undefined, partial_arg$2, partial_arg$1, undefined, undefined, /* [] */ 0, param, param$1);
                    };
                  }), param, param$1);
                }), param, param$1);
              }),
              tl: {
                hd: (function (param, param$1) {
                  return Lui_elements.scoped((function (__lui_context___005_) {
                    const partial_arg = {
                      TAG: /* Personal_tokens */ 40,
                      _0: /* Submit */ 5
                    };
                    const partial_arg$1 = (function (param) {
                      return Lui_elements.press(send, partial_arg, param);
                    });
                    const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (p) {
                      return !Mapre_web__Web_personal_tokens_model.can_submit(p);
                    }), source)));
                    const partial_arg$3 = "primary";
                    const partial_arg$4 = "Create personal token";
                    return function (param, param$1) {
                      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                    };
                  }), param, param$1);
                }),
                tl: {
                  hd: (function (param, param$1) {
                    return Lui_elements.scoped((function (__lui_context___006_) {
                      const partial_arg = {
                        TAG: /* Personal_tokens */ 40,
                        _0: /* Fresh */ 3
                      };
                      const partial_arg$1 = (function (param) {
                        return Lui_elements.press(send, partial_arg, param);
                      });
                      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map(busy, source)));
                      const partial_arg$3 = "outline";
                      const partial_arg$4 = "New token";
                      return function (param, param$1) {
                        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                      };
                    }), param, param$1);
                  }),
                  tl: /* [] */ 0
                }
              }
            }
          }
        }
      }
    }
  };
  const partial_arg$8 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$9 = 0;
  const partial_arg$10 = 8;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, param, param$1);
  };
}

function view(model, send) {
  const source = Signal.map((function (m) {
    return Stdlib__Option.value(m.personal_tokens, Mapre_web__Web_personal_tokens_model.initial(""));
  }), model);
  const partial_arg = "Personal access tokens";
  const partial_arg$1 = 2;
  const partial_arg$2 = "Use a Mapre token to connect external REST or MCP clients. Tokens belong to you and remain limited by your current permissions.";
  const partial_arg$3 = "muted";
  const partial_arg$4 = Signal.map((function (p) {
    return p.secret !== undefined;
  }), source);
  const partial_arg$5 = Signal.map((function (p) {
    return p.items;
  }), source);
  const partial_arg$6 = Signal.map((function (p) {
    return p.cursor !== undefined;
  }), source);
  const partial_arg$7 = {
    TAG: /* Personal_tokens */ 40,
    _0: /* Close */ 0
  };
  const partial_arg$8 = (function (param) {
    return Lui_elements.press(send, partial_arg$7, param);
  });
  const partial_arg$9 = "ghost";
  const partial_arg$10 = "Close personal tokens";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___015_) {
      const partial_arg = {
        TAG: /* Personal_tokens */ 40,
        _0: /* Refresh */ 1
      };
      const partial_arg$1 = (function (param) {
        return Lui_elements.press(send, partial_arg, param);
      });
      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___015_.ui_scope, Signal.map(busy, source)));
      const partial_arg$3 = "outline";
      const partial_arg$4 = "Refresh tokens";
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: /* [] */ 0
  };
  const partial_arg$11 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$12 = "wrap";
  const partial_arg$13 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.scoped((function (__lui_context___011_) {
          const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___011_.ui_scope, Signal.map((function (m) {
            const w = Stdlib__List.find_opt((function (w) {
              return Caml_obj.caml_equal(w.id, Mapre_web__Web_types.workspace(m.route));
            }), m.workspaces);
            if (w !== undefined) {
              return "Workspace: " + w.name;
            } else {
              return "Workspace unavailable";
            }
          }), model)));
          return function (param, param$1) {
            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
          };
        }), param, param$1);
      }),
      tl: {
        hd: inputs(model, source, send),
        tl: {
          hd: (function (param, param$1) {
            return Lui_elements.scoped((function (__lui_context___012_) {
              const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___012_.ui_scope, Signal.map((function (p) {
                return p.message;
              }), source)));
              const partial_arg$1 = "notice";
              return function (param, param$1) {
                return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param, param$1);
          }),
          tl: {
            hd: (function (param, param$1) {
              return Lui_elements.if_(partial_arg$4, (function (param, param$1) {
                return Lui_elements.scoped((function (__lui_context___013_) {
                  const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___013_.ui_scope, Signal.map((function (p) {
                    return Stdlib__Option.value(p.secret, "");
                  }), source)));
                  const partial_arg$1 = {
                    hd: [
                      "data-personal-token-secret",
                      "new"
                    ],
                    tl: /* [] */ 0
                  };
                  const partial_arg$2 = "token-secret";
                  return function (param, param$1) {
                    return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  };
                }), param, param$1);
              }), param, param$1);
            }),
            tl: {
              hd: (function (param, param$1) {
                return Lui_elements.keyed(partial_arg$5, (function (p) {
                  return p.id;
                }), Stdlib__String.compare, (function (param) {
                  const token = Signal.sample(param);
                  const partial_arg = {
                    TAG: /* Personal_tokens */ 40,
                    _0: {
                      TAG: /* Revoke */ 7,
                      _0: token.id
                    }
                  };
                  const partial_arg$1 = (function (param) {
                    return Lui_elements.press(send, partial_arg, param);
                  });
                  const partial_arg$2 = "ghost";
                  const partial_arg$3 = "Revoke token";
                  const partial_arg$4 = function (param, param$1) {
                    return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                  };
                  const partial_arg$5 = Signal.map((function (p) {
                    return !p.revoked;
                  }), param);
                  const partial_arg_0 = function (param$1, param$2) {
                    return Lui_elements.scoped((function (__lui_context___007_) {
                      const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___007_.ui_scope, Signal.map((function (p) {
                        return p.name;
                      }), param)));
                      return function (param, param$1) {
                        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                      };
                    }), param$1, param$2);
                  };
                  const partial_arg_1 = {
                    hd: (function (param$1, param$2) {
                      return Lui_elements.scoped((function (__lui_context___008_) {
                        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___008_.ui_scope, Signal.map((function (p) {
                          return p.prefix + ("... / " + Stdlib__String.concat(", ", p.scopes));
                        }), param)));
                        const partial_arg$1 = "muted";
                        return function (param, param$1) {
                          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                        };
                      }), param$1, param$2);
                    }),
                    tl: {
                      hd: (function (param$1, param$2) {
                        return Lui_elements.scoped((function (__lui_context___009_) {
                          const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___009_.ui_scope, Signal.map((function (p) {
                            if (p.revoked) {
                              return "Revoked";
                            } else if (p.expires_at <= Date.now()) {
                              return "Expired";
                            } else {
                              return "Active";
                            }
                          }), param)));
                          return function (param, param$1) {
                            return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                          };
                        }), param$1, param$2);
                      }),
                      tl: {
                        hd: (function (param$1, param$2) {
                          return Lui_elements.scoped((function (__lui_context___010_) {
                            const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___010_.ui_scope, Signal.map((function (p) {
                              return "Expires " + new Date(p.expires_at).toISOString();
                            }), param)));
                            const partial_arg$1 = "muted";
                            return function (param, param$1) {
                              return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                            };
                          }), param$1, param$2);
                        }),
                        tl: {
                          hd: (function (param, param$1) {
                            return Lui_elements.if_(partial_arg$5, partial_arg$4, param, param$1);
                          }),
                          tl: /* [] */ 0
                        }
                      }
                    }
                  };
                  const partial_arg$6 = {
                    hd: partial_arg_0,
                    tl: partial_arg_1
                  };
                  const partial_arg$7 = {
                    hd: [
                      "data-personal-token",
                      token.id
                    ],
                    tl: /* [] */ 0
                  };
                  const partial_arg$8 = "command-card";
                  const partial_arg$9 = 0;
                  const partial_arg$10 = 12;
                  const partial_arg$11 = 4;
                  return function (param, param$1) {
                    return Lui_elements.column(undefined, partial_arg$11, undefined, undefined, undefined, undefined, undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$8, partial_arg$7, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$6, param, param$1);
                  };
                }), param, param$1);
              }),
              tl: {
                hd: (function (param, param$1) {
                  return Lui_elements.if_(partial_arg$6, (function (param, param$1) {
                    return Lui_elements.scoped((function (__lui_context___014_) {
                      const partial_arg = {
                        TAG: /* Personal_tokens */ 40,
                        _0: /* More */ 2
                      };
                      const partial_arg$1 = (function (param) {
                        return Lui_elements.press(send, partial_arg, param);
                      });
                      const partial_arg$2 = Caml_option.some(Signal.own_signal(__lui_context___014_.ui_scope, Signal.map(busy, source)));
                      const partial_arg$3 = "outline";
                      const partial_arg$4 = "More tokens";
                      return function (param, param$1) {
                        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
                      };
                    }), param, param$1);
                  }), param, param$1);
                }),
                tl: {
                  hd: (function (param, param$1) {
                    return Lui_elements.row(undefined, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, undefined, partial_arg$11, param, param$1);
                  }),
                  tl: /* [] */ 0
                }
              }
            }
          }
        }
      }
    }
  };
  const partial_arg$14 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$15 = "form-card";
  const partial_arg$16 = 0;
  const partial_arg$17 = 16;
  const partial_arg$18 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$18, undefined, undefined, undefined, undefined, undefined, partial_arg$17, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$16, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$15, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$14, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
